// import React, { useState } from "react";
// import { Fab } from "@mui/material";
// import ChatIcon from "@mui/icons-material/Chat";

// const Chatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleChatbot = () => {
//     setIsOpen((prevState) => !prevState);
//   };

//   return (
//     <div>
//       {/* Floating Chatbot Button */}
//       <Fab
//         onClick={toggleChatbot}
//         style={{
//           position: "fixed",
//           bottom: "20px",
//           right: "100px",
//           zIndex: 1000,
//           backgroundColor: "#4CAF50",
//           height: "50px",
//           width: "50px",
//         }}
//       >
//         <ChatIcon style={{ color: "white" }} />
//       </Fab>

//       {/* Floating Chatbot Window */}
//       {isOpen && (
//         <div
//           style={{
//             position: "fixed",
//             bottom: "80px",
//             right: "20px",
//             width: "350px",
//             height: "430px",
//             zIndex: 999,
//             boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
//             borderRadius: "10px",
//             overflow: "hidden",
//           }}
//         >
//           <iframe
//             width="100%"
//             height="100%"
//             allow="microphone;"
//             src="https://console.dialogflow.com/api-client/demo/embedded/27d0fcfb-a017-4df7-bef1-4a544ca9bdec"
//             title="Chatbot"
//             style={{
//               border: "none",
//               borderRadius: "10px",
//             }}
//           ></iframe>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Chatbot;
import React, { useEffect, useState } from "react";
import { Fab } from "@mui/material";
import { BsWhatsapp } from "react-icons/bs"; // WhatsApp icon
import { Tooltip } from "@mui/material"; // Tooltip to show message when hovering
import { useTranslation } from "react-i18next";

const Chatbot = () => {
  const [isScrollTopVisible, setIsScrollTopVisible] = useState(false);
  const [showMessage, setShowMessage] = useState(false); // State to control text visibility
  const { t } = useTranslation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 110) {
        setIsScrollTopVisible(true);
      } else {
        setIsScrollTopVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Randomly show the "Click to chat on WhatsApp" message every 3-10 seconds
    const interval = setInterval(() => {
      setShowMessage(true); // Show message
      setTimeout(() => {
        setShowMessage(false); // Hide message after 3 seconds
      }, 3000); // Duration the message is shown
    }, Math.random() * (10000 - 3000) + 3000); // Random interval between 3-10 seconds

    // Cleanup the interval when component unmounts
    return () => {
      clearInterval(interval);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const phoneNumber = "918980863464";
  const message = "Hello, I need help!";
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <div>
      {/* Floating WhatsApp Button */}
      <Tooltip title={t("clickWhatsApp")} arrow>
        <Fab
          style={{
            position: "fixed",
            bottom: "20px",
            right: isScrollTopVisible ? "100px" : "20px",
            zIndex: 1000,
            height: "50px",
            width: "50px",
            transition: "right 0.3s",
            backgroundColor: "#25d366", // WhatsApp green color
          }}
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* WhatsApp Icon */}
          <BsWhatsapp style={{ color: "white", fontSize: "30px" }} />
        </Fab>
      </Tooltip>

      {/* Optional Text - Randomly displayed 
      {showMessage && (
        <div
          style={{
            position: "fixed",
            bottom: "80px", // Adjust based on your layout
            right: "20px",
            zIndex: 999,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            padding: "10px",
            borderRadius: "8px",
            animation: "fadeIn 1s ease-out",
          }}
        >
          <span>Click to chat on WhatsApp</span>
        </div>
      )} */}
    </div>
  );
};

export default Chatbot;
